export const getPayrollKey = (bid) => {
  const payroll = bid.payroll;
  const id = payroll?._id ?? payroll ?? "unknown";
  return id.toString();
};

export const getPayrollLabel = (bid) => {
  if (bid.payroll?.code) return bid.payroll.code;
  if (!bid.payroll) return "Not released";
  return getPayrollKey(bid);
};

const COMMISSION_CATEGORY_KEYS = {
  Initial: "commissionStatement.rowType.initial",
  Renewal: "commissionStatement.rowType.renewal",
  Trailing: "commissionStatement.rowType.trailing",
};

export const formatCommissionCategory = (value, translate) => {
  if (!value) return "";
  const t =
    typeof translate === "function" ? translate : (_key, fallback) => fallback;
  return String(value)
    .split(", ")
    .map((part) => {
      const key = COMMISSION_CATEGORY_KEYS[part];
      if (!key) return part;
      const translated = t(key, part);
      if (!translated || translated === key) return part;
      return translated;
    })
    .join(", ");
};

export const getConsultantLabel = (bid) =>
  bid.wallet?.name ||
  bid.wallet?.user?.name ||
  bid.wallet?.userGroup?.name ||
  bid.commissionRow?.user?.name ||
  bid.commissionRow?.userGroup?.name ||
  "-";
